/*
 * お届け予定日表示。
 *
 * 端末のタイムゾーンに依存しないよう、日付はすべて「JST の日番号」
 * （1970-01-01 JST からの通日）で扱い、表示のときだけ UTC ゲッタで
 * civil date を取り出す。Date のローカルメソッドは一切使わない。
 *
 * 設定値が読めない・稼働日が見つからない等の異常時は要素を hidden のままにする
 * （壊れた表示を出さない）。
 */
(function () {
  'use strict';
  if (window.customElements && window.customElements.get('delivery-estimate')) return;

  var MS_DAY = 86400000;
  var JST = 9 * 3600000;
  var WEEKDAY = ['日', '月', '火', '水', '木', '金', '土'];

  // 出荷（茨城）からの日数。ヤマト運輸のサービスレベル表による。
  // JP-01〜JP-47 の数値部分で引く。2〜34 が翌日、1 と 35〜46 が翌々日、47 が +3。
  function areaDays(code) {
    var n = parseInt(String(code || '').replace(/\D/g, ''), 10);
    if (!n || n < 1 || n > 47) return 0;
    if (n === 47) return 3;
    if (n === 1 || n >= 35) return 2;
    return 1;
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  // JST の通日。
  function dayIndex(ms) {
    return Math.floor((ms + JST) / MS_DAY);
  }

  // 通日 -> UTC 上の同じ civil date を指す Date（getUTC* で JST の年月日が取れる）。
  function dayDate(idx) {
    return new Date(idx * MS_DAY);
  }

  function isoDate(idx) {
    var d = dayDate(idx);
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
  }

  function formatDate(idx, withWeekday) {
    var d = dayDate(idx);
    var s = d.getUTCMonth() + 1 + '月' + d.getUTCDate() + '日';
    return withWeekday ? s + '（' + WEEKDAY[d.getUTCDay()] + '）' : s;
  }

  // 通日の JST 00:00 の絶対時刻。
  function dayStart(idx) {
    return idx * MS_DAY - JST;
  }

  // 日付以外の文字はすべて区切りとして扱う（改行・カンマ・全角空白どれでも可）。
  function dateSet(text) {
    var set = {};
    String(text || '')
      .split(/[^0-9-]+/)
      .forEach(function (s) {
        if (/^\d{4}-\d{2}-\d{2}$/.test(s)) set[s] = true;
      });
    return set;
  }

  function isOpenDay(cfg, idx) {
    var key = isoDate(idx);
    if (cfg.open[key]) return true;
    var dow = dayDate(idx).getUTCDay();
    if (dow === 0 || dow === 6) return false;
    if (cfg.holidays[key]) return false;
    if (cfg.closed[key]) return false;
    return true;
  }

  // idx 以降で最初の稼働日を返す。
  function nextOpenDay(cfg, idx) {
    for (var guard = 0; !isOpenDay(cfg, idx); guard++) {
      if (guard > 400) throw new Error('稼働日が見つからない');
      idx += 1;
    }
    return idx;
  }

  // 出荷日（通日）と締切までの残り時間を返す。
  //
  // リードタイム（名入れ・受注生産）がある商品は出荷日だけ後ろへずらす。
  // 締切は動かない（今日の 05:00 までに注文すれば、その日から製作が始まる）ので、
  // カウントダウンは必ず「通常の出荷日の締切」で測る。
  function shipping(cfg, now) {
    var hour = new Date(now + JST).getUTCHours();
    var idx = dayIndex(now);
    if (hour >= cfg.cutoff) idx += 1;

    var first = nextOpenDay(cfg, idx);
    var remaining = dayStart(first) + cfg.cutoff * 3600000 - now;

    // 通常の出荷日を 1 営業日目と数えるので、進めるのは lead - 1 営業日。
    var ship = first;
    for (var k = 1; k < cfg.lead; k++) {
      ship = nextOpenDay(cfg, ship + 1);
    }
    return { ship: ship, remaining: remaining };
  }

  // 切り捨て。ただし ms のゆらぎで「19時間ちょうど」が 18 時間に落ちないよう
  // いったん秒に丸めてから分・時に落とす。残り 1 分未満は「あと1分」に留める
  // （「あと0分」は壊れて見えるため）。
  function countdown(remaining) {
    var mins = Math.floor(Math.round(remaining / 1000) / 60);
    if (mins < 1) mins = 1;
    return mins >= 60 ? 'あと' + Math.floor(mins / 60) + '時間' : 'あと' + mins + '分';
  }

  // 沖縄（+3）だけは確定日にできないので曜日を出さず「以降」を付ける。
  function deliveryText(shipIdx, days) {
    if (days >= 3) return formatDate(shipIdx + days, false) + '以降';
    return formatDate(shipIdx + days, true);
  }

  // 検証用: ?de_now=2026-09-04T10:00 を JST として解釈する。
  // 経過時間は実時間どおり進むので、05:00 跨ぎもそのまま確認できる。
  var overrideBase = null;
  var overrideStart = 0;
  (function () {
    var m = /[?&]de_now=([^&]*)/.exec(window.location.search);
    if (!m) return;
    var p = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{1,2}):(\d{2})(?::(\d{2}))?)?$/.exec(
      decodeURIComponent(m[1]).replace(/\+/g, ' ')
    );
    if (!p) return;
    overrideBase = Date.UTC(+p[1], +p[2] - 1, +p[3], +(p[4] || 0), +(p[5] || 0), +(p[6] || 0)) - JST;
    overrideStart = Date.now();
  })();

  function nowMs() {
    return overrideBase === null ? Date.now() : overrideBase + (Date.now() - overrideStart);
  }

  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.line1El = this.querySelector('[data-de-line1]');
      this.line2El = this.querySelector('[data-de-line2]');
      // Dawn は商品ページ全体を <product-info> で包む。PageFly など無い場所では
      // スコープ限定をあきらめて document 全体の change を見る。
      // 選択中バリアントを探す範囲。狭いほうから順に当てる。
      // PageFly の通常ページ（/pages/...）は 1 ページに商品が 6〜27 個並ぶので、
      // ProductBox / フォームまで絞らないと隣の商品のセレクトを拾ってしまう。
      // （nurasan 系は商品間で色名が重複するため特に当たりやすい）
      this.scope =
        this.closest('product-info') ||
        this.closest('[data-pf-type="ProductBox"]') ||
        this.closest('form') ||
        this.closest('.product') ||
        null;

      try {
        this.config = this.readConfig();
      } catch (e) {
        this.config = null;
        return; // hidden のまま
      }

      // Shopify の available そのものではない。Liquid 側で予約・入荷待ち
      // （在庫追跡ありで実在庫 0 以下）を 0 に落としてある。
      this.inStock = this.dataset.deInstock === '1';
      // 描画後に別のバリアントが選ばれている場合（?variant= 付きの流入など）に備え、
      // 最初に画面の選択でそろえる。
      var initial = this.resolveVariantId();
      if (initial !== null) this.applyVariant(initial);

      this.onVariantChange = this.handleVariantChange.bind(this);
      document.addEventListener('change', this.onVariantChange);
      this.variantTimer = window.setInterval(() => this.checkVariant(), 400);

      this.onVisible = () => {
        if (!document.hidden) this.render();
      };
      document.addEventListener('visibilitychange', this.onVisible);

      this.render();
      this.timer = window.setInterval(() => this.render(), 60000);
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
      if (this.variantTimer) window.clearInterval(this.variantTimer);
      if (this.onVariantChange) document.removeEventListener('change', this.onVariantChange);
      if (this.onVisible) document.removeEventListener('visibilitychange', this.onVisible);
      this.initialized = false;
    }

    readConfig() {
      var cutoff = parseInt(this.dataset.deCutoff, 10);
      if (!(cutoff >= 0 && cutoff <= 23)) throw new Error('締切時刻が不正: ' + this.dataset.deCutoff);

      var list = JSON.parse(this.dataset.deVariants || '[]');
      var variants = {};
      list.forEach(function (v) {
        variants[String(v.id)] = v.s === 1;
      });

      // リードタイム（営業日）。タグの打ち間違いで何年も先を指さないよう上限を置く。
      var lead = parseInt(this.dataset.deLead, 10);
      if (!(lead >= 1)) lead = 1;
      if (lead > 60) lead = 60;

      return {
        cutoff: cutoff,
        holidays: dateSet(this.dataset.deHolidays),
        open: dateSet(this.dataset.deOpen),
        closed: dateSet(this.dataset.deClosed),
        line2: this.dataset.deLine2 || '',
        area: areaDays(this.dataset.deProvince),
        lead: lead,
        variants: variants,
        list: list,
      };
    }

    // 選択中バリアントは、本来フォームの hidden input[name="id"] に入る。
    variantInput() {
      // スコープが取れているなら、その外は見ない。複数商品が並ぶページで
      // 隣の商品の input を拾わないため。
      if (this.scope) return this.scope.querySelector('input[name="id"]');
      return document.querySelector('input[name="id"]');
    }

    // いま画面で選ばれているオプション値をぜんぶ集める。
    // 見えているセレクトだけを見るのが肝心。YMP（Giraffly）は同じ内容の
    // 隠しセレクトを別に持っていて、値が古いまま残ることがあるため。
    // Dawn のバリアントピルはラジオが視覚的に隠れているので、こちらは checked を全部拾う。
    selectedOptionValues() {
      var root = this.scope || document;
      var values = {};
      var selects = root.querySelectorAll('select');
      var i;
      for (i = 0; i < selects.length; i++) {
        if (selects[i].offsetParent !== null) values[selects[i].value] = true;
      }
      var radios = root.querySelectorAll('input[type="radio"]:checked');
      for (i = 0; i < radios.length; i++) values[radios[i].value] = true;
      return values;
    }

    // 選択中バリアントの ID を決める。
    // オプション値から引き当てられればそれを優先し、駄目なら hidden input を見る。
    resolveVariantId() {
      var list = this.config.list || [];
      if (list.length) {
        var values = this.selectedOptionValues();
        for (var i = 0; i < list.length; i++) {
          var parts = list[i].o || [];
          if (!parts.length) continue;
          var all = true;
          for (var k = 0; k < parts.length; k++) {
            if (!values[parts[k]]) {
              all = false;
              break;
            }
          }
          if (all) return String(list[i].id);
        }
      }
      var input = this.variantInput();
      return input ? String(input.value || '') : null;
    }

    // 在庫状態を取り直す。実際に変わったときだけ true を返す。
    applyVariant(value) {
      value = String(value == null ? '' : value);
      if (value === this.lastVariant) return false;
      this.lastVariant = value;
      if (value === '') {
        this.inStock = false; // 条件に合うバリアントが無い
      } else if (Object.prototype.hasOwnProperty.call(this.config.variants, value)) {
        this.inStock = this.config.variants[value];
      } else {
        return false; // 知らない ID。判断材料がないので現状維持
      }
      return true;
    }

    // なぜ値を見張るのか:
    //   Dawn は input[name="id"] を書き換えたあと change を投げるが、
    //   **PageFly は値を代入するだけでイベントを投げない**（2026-09-01 に実機で確認）。
    //   value プロパティへの代入は属性を変えないので MutationObserver でも拾えない。
    //   1 つの input の value を読むだけなので、短い間隔で見ても負荷にならない。
    checkVariant() {
      if (document.hidden) return;
      var id = this.resolveVariantId();
      if (id === null) return;
      if (this.applyVariant(id)) this.render();
    }

    // Dawn 側は change が飛ぶので、ポーリングを待たずその場で反映する。
    handleVariantChange() {
      this.checkVariant();
    }

    render() {
      if (!this.config) return;
      if (!this.inStock) {
        this.hidden = true;
        return;
      }

      var line1;
      var line2;
      try {
        var r = shipping(this.config, nowMs());
        // 都道府県が分かるときはその日数で 1 行目を出し、2 行目は出さない。
        var days = this.config.area || 1;
        var body = deliveryText(r.ship, days) + 'お届け予定';
        line1 = r.remaining <= MS_DAY ? countdown(r.remaining) + '以内のご注文で ' + body : body;
        line2 = this.config.area
          ? ''
          : this.config.line2
              .replace('{d2}', formatDate(r.ship + 2, true))
              .replace('{d3}', formatDate(r.ship + 3, false));
      } catch (e) {
        this.hidden = true;
        return;
      }

      if (this.line1El) this.line1El.textContent = line1;
      if (this.line2El) {
        this.line2El.textContent = line2;
        this.line2El.hidden = !line2;
      }
      this.hidden = false;
    }
  }

  window.customElements.define('delivery-estimate', DeliveryEstimate);
})();
